import { useMemo } from "react"

import { Typography } from "@mui/material"

import * as Styled from "./YearSelector.styled"

export const YearSelector = (props: YearSelectorProps) => {

    const {
        className,
        onClick,
        selectedValue = null,
        title,
        yearlyStatuses,
        ...otherProps
    } = props

    const options = useMemo(() => {
        if (!yearlyStatuses?.length) {
            return []
        }

        return yearlyStatuses.map((yearlyStatus) => (
            <Styled.Button
                disabled={yearlyStatus.disabled}
                id={`year-selector-button-${yearlyStatus.date}`}
                key={`network-${yearlyStatus.date}`}
                onClick={() => onClick(yearlyStatus.value)}
                selected={selectedValue?.uuid === yearlyStatus.value?.uuid}
            >
                <Styled.Text
                    color={yearlyStatus.disabled ? "text/disabled" : "common/black_states"}
                    variant="Desktop & Mobile/Body/Light"
                >
                    {yearlyStatus.date}
                    {yearlyStatus.badgeComponent}
                </Styled.Text>
            </Styled.Button>
        ))
    }, [onClick, selectedValue, yearlyStatuses])

    if (!options.length) {
        return null
    }

    return (
        <Styled.Wrapper>
            {title && <Typography variant="Desktop & Mobile/Body/Small">{title}</Typography>}
            <Styled.OptionsWrapper className={className} {...otherProps}>
                {options}
            </Styled.OptionsWrapper>
        </Styled.Wrapper>
    )
}

type YearItem = {
    badgeComponent?: React.ReactNode
    disabled?: boolean
    date: number
    value: { uuid: number }
    uuid?: string
}

type YearSelectorProps = {
    className?: string
    onClick: (_value: YearItem["value"]) => void
    selectedValue?: YearItem["value"] | null
    title?: string
    yearlyStatuses: YearItem[]
}
